import Const from 'beek-design-system/config/Const';

const nunitoBaseUrl = `${Const.cdnUrl}/design-system/fonts/nunito-sans-v6-latin`;

export default `
  /* System Fonts */

  /* nunito-sans-regular - latin */
  @font-face {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 400;
    font-display: swap;
    src: url('${nunitoBaseUrl}/nunito-sans-v6-latin-regular.eot'); /* IE9 Compat Modes */
    src: local(''),
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-regular.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-regular.woff2') format('woff2'), /* Super Modern Browsers */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-regular.woff') format('woff'), /* Modern Browsers */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-regular.ttf') format('truetype'), /* Safari, Android, iOS */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-regular.svg#NunitoSans') format('svg'); /* Legacy iOS */
  }
  /* nunito-sans-600 - latin */
  @font-face {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 600;
    font-display: swap;
    src: url('${nunitoBaseUrl}/nunito-sans-v6-latin-600.eot'); /* IE9 Compat Modes */
    src: local(''),
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-600.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-600.woff2') format('woff2'), /* Super Modern Browsers */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-600.woff') format('woff'), /* Modern Browsers */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-600.ttf') format('truetype'), /* Safari, Android, iOS */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-600.svg#NunitoSans') format('svg'); /* Legacy iOS */
  }
  /* nunito-sans-700 - latin */
  @font-face {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 700;
    font-display: swap;
    src: url('${nunitoBaseUrl}/nunito-sans-v6-latin-700.eot'); /* IE9 Compat Modes */
    src: local(''),
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-700.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-700.woff2') format('woff2'), /* Super Modern Browsers */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-700.woff') format('woff'), /* Modern Browsers */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-700.ttf') format('truetype'), /* Safari, Android, iOS */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-700.svg#NunitoSans') format('svg'); /* Legacy iOS */
  }
  /* nunito-sans-800 - latin */
  @font-face {
    font-family: 'Nunito Sans';
    font-style: normal;
    font-weight: 800;
    font-display: swap;
    src: url('${nunitoBaseUrl}/nunito-sans-v6-latin-800.eot'); /* IE9 Compat Modes */
    src: local(''),
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-800.eot?#iefix') format('embedded-opentype'), /* IE6-IE8 */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-800.woff2') format('woff2'), /* Super Modern Browsers */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-800.woff') format('woff'), /* Modern Browsers */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-800.ttf') format('truetype'), /* Safari, Android, iOS */
        url('${nunitoBaseUrl}/nunito-sans-v6-latin-800.svg#NunitoSans') format('svg'); /* Legacy iOS */
  }


  body {
    font-family: 'Nunito Sans', sans-serif;
  }
`;
